module.exports = __webpack_public_path__ + "img/ben-home-hero.43693100.svg";